import { createInputDraftApplicationService } from '@/ikkodate/application/drafts/inputDraftApplicationService'
import { createBrowserStoragePort } from '@/2D3DEditer/ports/storagePort'
import { createInputDraftRepository } from '@/ikkodate/repositories/inputDraftRepository'

/**
 * Composes session storage for the input-draft Application service.
 * The default parameter is evaluated only when this factory is called.
 *
 * @param {import('@/2D3DEditer/ports/storagePort').StoragePort} [storage]
 */
export function createSessionInputDraftApplication(storage = sessionStorage) {
  return createInputDraftApplicationService({
    inputDraftRepository: createInputDraftRepository(createBrowserStoragePort(storage))
  })
}